// HeroSlide2.jsx
import React from "react";
import styled from "styled-components";
import SliderPhone2 from "../../../assets/img/SliderPhone2.png";
import Slider2 from "../../../assets/img/Slider2.png";

const SlideWrapper = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 1840/879;
  border-radius: 30px;
  background-image: url(${Slider2});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  h2 {
    font-size: clamp(1.4rem, 5vw, 4.5rem);
    font-weight: bold;
    padding: 5rem;
    color: white;
  }
  p {
    display: none;
  }
  @media (max-width: 768px) {
    aspect-ratio: 990/1408;
    border-radius: 0px;
    height: auto;
    background-image: url(${SliderPhone2});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    h2 {
      display: none;
    }
    p {
      display: block;
      font-size: clamp(1.4rem, 6.5vw, 3rem);
      font-weight: bold;
      padding: 2rem;
      color: white;
    }
  }
`;

const HeroSlide2 = () => {
  return (
    <SlideWrapper>
      <p>
        Conectamos empresas y <br />
        transportistas en una plataforma ágil, segura y <br />
        sin intermediarios.
      </p>
      <h2>
        Conectamos empresas y <br />
        transportistas en una <br />
        plataforma ágil, segura y <br />
        sin intermediarios.
      </h2>
    </SlideWrapper>
  );
};

export default HeroSlide2;
